<script setup lang="ts">
import { toRefs } from 'vue';

interface MessageInterface {
  main: string;
  sub: string;
  dateTime: { date: string; time: string }[];
}

interface Props {
  message: MessageInterface;
  styleClass?: string;
}

const props = defineProps<Props>();

const { message, styleClass } = toRefs(props);
</script>

<template>
  <div :class="styleClass">
    <span class="font-semibold" v-text="message.main" />
    <span class="ml-1" v-text="message.sub" />
  </div>

  <div class="mt-2 text-sm">
    <span v-text="'Conflicts on:'" />
    <ul>
      <li v-for="(dt, index) in message.dateTime" :key="index">
        <span class="font-semibold" v-text="dt.date" />
        <span class="ml-1" v-text="dt.time" />
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss"></style>
